<template>
  <div class="log-out">
    <div class="container">
      <div class="row">
        <div class="col-12 thanks header-text ">
          <h1>{{ $t('views.logout.thankYouForChoosing') }}<span class="blue"></span></h1>
          <img alt="Income Marketplace" class="logo" src="../assets/income.svg">
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="equal-opportunity">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-5 col-xl-5 ">
                  <div class="bg-column">
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 col-xl-7 text">
                  <div class="info">
                    <span class="blue">{{ $t('views.logout.help') }}</span>{{ $t('views.logout.usImprove') }}<br/>
                    <span class="blue">{{ $t('views.logout.give') }}</span>{{ $t('views.logout.feedback') }}<div class="footer-register">
                      <b-button class="join" :to="feedbackPath" @click.native="scrollToTop">{{ $t('views.logout.clickHere') }}</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import localStorageHelper from '@/helpers/localStorageHelper'
import {urlPrefix} from '@/helpers/localePrefix'

export default {
  name: 'Logout',
  head: {
    meta: [
      {
        name: 'description',
        content: 'Thank you for choosing Income Marketplace!',
        id: 'desc'
      }
    ]
  },
  computed: {
    feedbackPath()
    {
      return urlPrefix(this.$i18n.locale) + '/' + this.$t('router.links.feedback')
    }
  },
  mounted()
  {
    if (localStorageHelper.get('showClosedAccountMsg'))
    {
      this.$root.$emit('showclosedaccount', true)
      localStorageHelper.remove('showClosedAccountMsg')
    }
  },
  methods: {
    scrollToTop()
    {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped lang="scss">

.header-text {
  text-align: center;
  margin: 82px auto 16px 0;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    color: #000000;
  }

  .logo {
    margin-top: 25px;
    margin-bottom: 60px;
    width: 100%;
    max-width: 300px;
  }
}

.equal-opportunity {
  border: 1px solid #D6D6D6;
  box-sizing: border-box;
  border-radius: 10px;
  height: auto;
  margin-bottom: 40px;
  margin-top: 40px;

  .bg-column {
    background-image: url("../assets/crosses-bg.png");
    background-position: left 0;
    background-repeat: no-repeat;
    background-size: contain;
    min-height: 255px;
    height: 100%;
    margin: 0;
    padding: 0;
    width: 100%;
    display: inline-block;
  }

  .text {
    margin-top: 100px;
    margin-bottom: 100px;

    .head {
      font-style: normal;
      font-weight: bold;
      font-size: 36px;
      line-height: 40px;
      color: #000000;
      flex: none;
      order: 0;
      align-self: flex-start;
      margin: 0 16px;
    }

    .info {
      font-style: normal;
      font-weight: 700;
      font-size: 36px;
      line-height: 40px;
      flex: none;
      order: 1;
      align-self: flex-start;
      margin: 0 16px;
      text-align: center;
    }
  }
}

.footer-register {
  margin-top: 20px;
  margin-bottom: 20px;
}

@media only screen and (min-width: 320px) and (max-width: 480px) {
  .equal-opportunity {
    background-size: cover;

    .bg-column {
      min-height: 185px;
    }

    .text {
      margin-top: 25px !important;
    }

    .info {
      font-size: 28px !important;
    }

    .head {
      margin: 30px 16px !important;
    }
  }
}

@media only screen and (max-width: 764px) {
  .equal-opportunity {
    .head {
      margin: 85px 16px;
    }
  }
}

@media only screen and (max-width: 1204px) {

  .equal-opportunity {
    .text {
      /*margin: 10px*/
      margin-bottom: 10px;
      margin-top: 50px;
    }
  }
}

.join {
  background: #30A7FE;
  color: white;
  border: none;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 34px;
  text-transform: uppercase;
  max-width: 300px;
  width: 100%;
}
</style>
